import React from 'react';
import LitImage from './images/LitImage';
import { graphql } from 'gatsby';

const ModularImageSecondaryImage = ({ data }) => {
  const {
    backgroundColor,
    noBottomPadding,
    noTopPadding,
    caveatText,
    imagePairBlock,
  } = data;
  return (
    <div className={`trustpilot-comparison-container ${backgroundColor}}`}>
      <div
        className={`modular-global-width   ${
          noBottomPadding && 'modular-padding-large-no-bottom'
        } ${noTopPadding && 'modular-padding-large-no-top'} ${
          !noBottomPadding && !noBottomPadding && 'modular-padding-large'
        }`}
      >
        <div className="trustpilot-comparison-inner">
          {imagePairBlock.map(({ image, secondaryImage }) => {
            return (
              <div className="trustpilot-comparison-image-container">
                <div className="image">
                  <LitImage image={image} />
                </div>
                <div className="secondary-image">
                  <LitImage image={secondaryImage} />
                </div>
              </div>
            );
          })}
        </div>
        <div className="trustpilot-comparison-caveat-text">{caveatText}</div>
      </div>{' '}
    </div>
  );
};

export default ModularImageSecondaryImage;
export const fragment = graphql`
  fragment ModularImageSecondaryImage on DatoCmsImageSecondaryImageBlock {
    internal {
      type
    }
    backgroundColor
    noBottomPadding
    noTopPadding
    caveatText
    imagePairBlock {
      image {
        gatsbyImageData
      }
      secondaryImage {
        gatsbyImageData
      }
    }
  }
`;
